import React, { useEffect, useRef, useState } from 'react'
import style from './Joystick.module.css'
import renderPrgImage from '../../../../source/programImg'

export default function Joystick({
    type = 'horizontal', // "horizontal" | "vertical"
    size = 160,
    stickSize = 60,
    onChange,
}) {
    const baseRef = useRef(null)
    const [pos, setPos] = useState({ x: 0, y: 0 })

    // const radius = size / 2
    // const maxMove = radius - stickSize / 2
    const getMetrics = () => {
        const rect = baseRef.current.getBoundingClientRect()
        const radius = rect.width / 2
        const maxMove = radius - stickSize / 2
        return { rect, radius, maxMove }
    }

    useEffect(() => {
        const handleResize = () => setPos({ x: 0, y: 0 })
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const updatePosition = (clientX, clientY) => {
        // const rect = baseRef.current.getBoundingClientRect()
        const { rect, radius, maxMove } = getMetrics()

        let x = clientX - rect.left - radius
        let y = clientY - rect.top - radius
        // console.log('HHHHHHHHHH')
        if (type === 'horizontal') {
            x = Math.max(-maxMove, Math.min(maxMove, x))
            y = 0
            onChange?.({ x: x / maxMove, y: 0 })
        } else {
            y = Math.max(-maxMove, Math.min(maxMove, y))
            x = 0
            onChange?.({ x: 0, y: y / maxMove })
        }

        setPos({ x, y })
    }

    const start = (e) => {
        const move = (ev) => {
            const point = ev.touches ? ev.touches[0] : ev
            updatePosition(point.clientX, point.clientY)
        }

        const stop = () => {
            setPos({ x: 0, y: 0 })
            onChange?.({ x: 0, y: 0 })
            window.removeEventListener('mousemove', move)
            window.removeEventListener('mouseup', stop)
            window.removeEventListener('touchmove', move)
            window.removeEventListener('touchend', stop)
        }

        window.addEventListener('mousemove', move)
        window.addEventListener('mouseup', stop)
        window.addEventListener('touchmove', move)
        window.addEventListener('touchend', stop)
    }

    return (
        <div
            ref={baseRef}
            className={`${style.joystickBaseMan} ${
                type === 'horizontal'
                    ? style.joystickBase
                    : style.joystickVerticalBase
            } `}
            // style={{ width: size, height: size }}
            onMouseDown={start}
            onTouchStart={start}
        >
            {type === 'horizontal' && (
                <img
                    src={renderPrgImage('joystickLeftArrow')}
                    className={style.leftArrow}
                />
            )}
            {type === 'horizontal' && (
                <img
                    src={renderPrgImage('joystickRightArrow')}
                    className={style.rightArrow}
                />
            )}
            {type === 'vertical' && (
                <img
                    src={renderPrgImage('joystickUpArrow')}
                    className={style.upArrow}
                />
            )}
            {type === 'vertical' && (
                <img
                    src={renderPrgImage('joystickDownArrow')}
                    className={style.downArrow}
                />
            )}
            <div
                className={style.joystickStick}
                style={{
                    // width: stickSize,
                    // height: stickSize,
                    transform: `translate(${pos.x}px, ${pos.y}px)`,
                }}
            />
        </div>
    )
}
